module.exports = __webpack_public_path__ + "media/images/3_5-56142a5d779548f15f3dac6012014186.png";